import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {  SatHachs_CauHoi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { EmitType, detach } from '@syncfusion/ej2-base';
import { UploaderComponent, RemovingEventArgs, SelectedEventArgs, SuccessEventArgs, FileInfo } from '@syncfusion/ej2-angular-inputs';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogComponent, ButtonPropsModel, PositionDataModel, ResizeDirections } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';

import { SelectionService, EditService, SelectionSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { RichTextEditorComponent, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { FileManagerComponent, FileOpenEventArgs, FileSelectEventArgs } from '@syncfusion/ej2-angular-filemanager';


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-tuvankhoahocedit',
  templateUrl: './tuvankhoahocedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./tuvankhoahocedit.component.scss'],
  providers: [ListService, Repository, WindowRef, MaskedDateTimeService, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService],
  encapsulation: ViewEncapsulation.None
})


export class tuvankhoahoceditComponent implements OnInit {
  private hostUrl: string = '/';
  // upload
  @ViewChild('uploadObj')
  public uploadObj: UploaderComponent;
  @ViewChild('dialogObj')
  public dialogObj: DialogComponent;
  @ViewChild('filemanagerObj')
  public filemanagerObj: FileManagerComponent;
  public dialogHeader = 'Chọn tệp ảnh';
  public animationSettings: Object = { effect: 'None' };
  public showCloseIcon = true;
  public target = '#target';
  public visible = false;
  public dialogWidth = '850px';
  public contextmenuItems: string[] = ['Open', '|', 'Cut', 'Copy', 'Delete', 'Rename', '|', 'Details'];
  ajaxSettings = {
    url: this.hostUrl + 'FileUpLoadManager/FileOperations',
    getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
    uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
    downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
  };
  public btnClick: EmitType<object> = () => {
    //if (document.getElementById('target').classList.contains('upload-dialog1')) {
    //  document.getElementById('target').classList.remove('upload-dialog1');
    //}
    //document.getElementById('target').classList.add('upload-dialog');
    this.dialogObj.show();
    this.dialogOpen();
    this.filemanagerObj.path = '/';
    this.filemanagerObj.selectedItems = [];
    this.filemanagerObj.refresh();
  }

  // Uploader will be hidden, if Dialog is opened
  public dialogOpen: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'none';
  }
  // Uploader will be shown, if Dialog is closed
  public dialogClose: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'block';
  }
  OnbeforeSend(args) {

    var data = JSON.parse(args.ajaxSettings.data);
    if (args.action == 'Upload') {
      //data[0]["CodeClass"] = this.codeClass;
      //data[0]["Loai"] = 1;
      data.push({ codeclass: 'ThuVien' });
      data.push({ PathFolder: "~/Upload/ThuVien" });
      data.push({ loai: 1 });
      args.ajaxSettings.data = JSON.stringify(data);
    }
    else {
      data["CodeClass"] = 'ThuVien';
      data["DonVi"] = null;
      data["PathFolder"] = "~/Upload/ThuVien";
      data["Loai"] = 1;
      args.ajaxSettings.data = JSON.stringify(data);
    }

  };
  // File Manager's fileOpen event function
  public onFileOpen(args: FileOpenEventArgs): void {
    let file = (args as any).fileDetails;
    if (file.isFile) {
      args.cancel = true;
      if (file.size <= 0) { file.size = 10000; }
      this.uploadObj.files = [{ name: file.name, size: file.size, type: file.type }];
      // let filterPath = "/Content/Files" + file.filterPath.replace('\\', '/') + file.name;
      let filterPath = '/Upload/ThuVien' + '/' + file.filterPath.replace('\\', '/').replace('\\', '/').replace('\\', '/').replace('\\', '/') + '/' + file.name;
      this.doituongSelect.DuongDanAnh = filterPath;
      this.dialogObj.hide();
      //if (document.getElementById('target').classList.contains('upload-dialog')) {
      //  document.getElementById('target').classList.remove('upload-dialog');
      //}
      //document.getElementById('target').classList.add('upload-dialog1');

    }
  }
  public ngOnDestroy(): void {
    //if (document.getElementById('target').classList.contains('upload-dialog')) {
    //  document.getElementById('target').classList.remove('upload-dialog');
    //}
  }

  toolbarSettings = {
    items: ['NewFolder', 'Upload', 'Delete', 'Cut', 'Copy', 'Rename', 'SortBy', 'Refresh', 'Selection', 'View', 'Details']
  };
  contextMenuSettings = {
    file: this.contextmenuItems,
    folder: this.contextmenuItems
  };
  taifile(src: string) {
    console.log(src);
    window.location.href = src;
  }
  deleteFile() {
    this.doituongSelect.DuongDanAnh = null;
  }

  // upload




  alertMsg: any;
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;
  public tools: ToolbarModule = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };

  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileUpLoadManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
      uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
      downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
    }
  };





  public quickToolbarSettings: QuickToolbarSettingsModel = {
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public width: string = '98%';
  // public animationSettings: AnimationSettingsModel = { effect: 'None' };
  // public target: string = '.control-section';
  public maxLength = 20000;
  public textArea: HTMLElement;
  public myCodeMirror: any;
  public value: any;


  public mirrorConversion(e?: any): void {
    const id: string = this.rteObj.getID() + 'mirror-view';
    let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
    const charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
    if (e.targetItem === 'Preview') {
      this.textArea.style.display = 'block';
      mirrorView.style.display = 'none';
      this.textArea.innerHTML = this.myCodeMirror.getValue();
      charCount.style.display = 'block';
    } else {
      if (!mirrorView) {
        mirrorView = createElement('div', { className: 'e-content' });
        mirrorView.id = id;
        this.textArea.parentNode.appendChild(mirrorView);
      } else {
        mirrorView.innerHTML = '';
      }
      this.textArea.style.display = 'none';
      mirrorView.style.display = 'block';
      this.renderCodeMirror(mirrorView, this.rteObj.value);
      charCount.style.display = 'none';
    }
  }

  public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
    this.myCodeMirror = CodeMirror(mirrorView, {
      value: content,
      lineNumbers: true,
      mode: 'text/html',
      lineWrapping: true,

    });
  }
  public handleFullScreen(e: any): void {
    const sbCntEle: HTMLElement = document.querySelector('.sb-content.e-view');
    const sbHdrEle: HTMLElement = document.querySelector('.sb-header.e-view');
    const leftBar: HTMLElement = document.querySelector('#left-sidebar');
    if (e.targetItem === 'Maximize') {
      if (Browser.isDevice && Browser.isIos) {
        addClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      addClass([leftBar], ['e-close']);
      removeClass([leftBar], ['e-open']);
    } else if (e.targetItem === 'Minimize') {
      if (Browser.isDevice && Browser.isIos) {
        removeClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      removeClass([leftBar], ['e-close']);
      if (!Browser.isDevice) {
        addClass([leftBar], ['e-open']);
      }
    }
  }
  public actionCompleteHandler(e: any): void {
    console.log("actiondsdsd");
    console.log(e);
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
      (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
      this.mirrorConversion(e);
    } else {
      setTimeout(() => {
        this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
        this.rteObj.toolbarModule.refreshToolbarOverflow();
      }, 400);
    }
  }



  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputloaicauhois: any
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, HoVaTen: null, DienThoai: null, NamSinh: null
    , GhiChu: null, NoiDungTuVan: null
    , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    , KhoaHocId: null, TrangThaiXuLy: null

  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputloais: any = [{ Id: 0, Ten: 'Đúng sai' }, { Id: 1, Ten: 'Một lựa chọn' }, { Id: 2, Ten: 'Nhiều lựa chọn' }, { Id: 3, Ten: 'Tự luận' }]

  inputhinhthucthanhtoans: any = [{ Id: 0, Ten: 'Thanh toán tại nhà' }, { Id: 1, Ten: 'Chuyển khoản' }]

  inputmonhocs: any;
  inputloaikhoanluongs: any = [{ Id: 1, Name: 'Thu nhập thường xuyên' }, { Id: 2, Name: 'Thu nhập không thường xuyên' }, { Id: 3, Name: 'Khấu trừ thường xuyên' }, { Id: 4, Name: 'Khấu trừ không thường xuyên' }]
  inputloaikieunhaps: any = [{ Id: 1, Name: 'Số tiền' }, { Id: 2, Name: 'Tỷ lệ (%)' }, { Id: 3, Name: 'Hệ số' }]
  inputloaikhoans: any;
  inputloaithis: any;
  inputtaikhoantaisans: any;
  inputmucdocauhois: any;
  inputtinhs: any;
  inputhuyens: any;
  inputxas: any;

  file: any;
  idnew: string;
  hienthianh: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };


  constructor(private _dataService: ListService, public repo: Repository, private sanitizer: DomSanitizer) {


  }
  transformYourHtml(htmlTextWithStyle) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }
  ngOnInit(): void {
    //document.getElementById('target').classList.add('upload-dialog1');
    //document.getElementById('defaultfileupload').style.display = 'none';
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
      this.rteObj.toolbarModule.refreshToolbarOverflow();
    }, 400);
  } 




  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  public dviid: string;
  bledit: boolean = false;
  currentUser: any;
  tudanhsach: number;
  khoahocid: number;

  public changeTinh($event: any) {

    if (typeof $event === "undefined") {
      this.doituongSelect.HuyenId = null;
      this.doituongSelect.XaId = null;
    }
    else {
      // this.chungtuSelect.ChiTiets[index].Tai_Khoan_No_Id = $event.Id;
      this.repo.postRequest("api/khoahoc/gethuyen/", { Id: $event.Id })
        .subscribe(response => {
          this.inputhuyens = response;
        });
    }

  }
  public changeHuyen($event: any) {

    if (typeof $event === "undefined") {
      this.doituongSelect.XaId = null;
    }
    else {
      // this.chungtuSelect.ChiTiets[index].Tai_Khoan_No_Id = $event.Id;
      this.repo.postRequest("api/khoahoc/getxa/", { Id: $event.Id })
        .subscribe(response => {
          this.inputxas = response;
        });
    }

  }

  loadDataInit(nhomdoituongid: string, id: string, donviid: string, khoahocid: number, tudanhsach: number) {
    this.tudanhsach = tudanhsach;
    this.khoahocid = khoahocid;
    //this.repo.postRequest("api/khoahoc/gettinh/", { Id: 1 })
    //  .subscribe(response => {
    //    this.inputtinhs = response;
    //  });


    this.dviid = donviid;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === SatHachs_CauHoi.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);

    //this.doituongSelect.AnhString = null;
    this.hienthianh = false;
    $('#preview').attr('src', "/assets/img/anhdt.gif");


    this.doituongSelect = {
      Id: null, HoVaTen: null, DienThoai: null, NamSinh: null
      , GhiChu: null, NoiDungTuVan: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , KhoaHocId: this.khoahocid, TrangThaiXuLy: false


    };
    this.ngaybatdau = null;
    this.ngayketthuc = null;
    if (id === null) {

      this.doituongSelect.TrangThaiXuLy = false;
      this.bledit = false;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.Modified = new Date();
      if (this.currentUser !== null) {
        this.doituongSelect.CreatedBy = this.currentUser.user_name;
        this.doituongSelect.ModifiedBy = this.currentUser.user_name;
      }
      setTimeout(() => {
        this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
        this.rteObj.toolbarModule.refreshToolbarOverflow();
      }, 400);
      //this.repo.postRequest("api/khoahoc/getnoidungthanhtoan/", { Id: this.khoahocid })
      //  .subscribe(response => {
      //    if (response !== null)
      //      this.doituongSelect.NoiDungChuyenKhoan = response[0].NoiDungChuyenKhoan;
      //  });


    }
    else {
      this.bledit = true;
      console.log("t11");
      this.repo.getRequest("api/tuvankhoahoc/getmodel/" + id)
        .subscribe(response => {
          this.doituongSelect.Id = id;

          this.doituongSelect.HoVaTen = response.HoVaTen;
          this.doituongSelect.DienThoai = response.DienThoai;
          this.doituongSelect.NamSinh = response.NamSinh;
          this.doituongSelect.GhiChu = response.GhiChu;
          this.doituongSelect.NoiDungTuVan = response.NoiDungTuVan;
          this.doituongSelect.KhoaHocId = response.KhoaHocId;
          this.doituongSelect.TrangThaiXuLy = response.TrangThaiXuLy;


          this.doituongSelect.Created = response.Created;
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;

          setTimeout(() => {
            this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
            this.rteObj.toolbarModule.refreshToolbarOverflow();
          }, 400);

        });
    }

  

  }
  Tai_Anh() {

    this.doituongSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.doituongSelect.XoaAnh = 0;
    $('#preview').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    console.log("tt");
    //console.log(event);
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.doituongSelect.AnhString = btoa(binaryString);  // Converting binary string data.

    $('#preview').attr('src', "data:image/png;base64," + this.doituongSelect.AnhString + "");

  }
  //  keyTenPress(event: any) { 
  //      if (event.which === 13) {
  //        this.slLoaiKhoanLuong.focus();
  //          event.preventDefault();
  //        }
  //}

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.Id == null)
      this.doituongSelect.Id = 0;

    if (this.doituongSelect.HoVaTen == null || this.doituongSelect.HoVaTen == "") {
      swal('Lỗi!', 'Vui lòng nhập họ và tên!.', 'error');
      return;
    }
    if (this.doituongSelect.DienThoai == null || this.doituongSelect.DienThoai == "") {
      swal('Lỗi!', 'Vui lòng nhập điện thoại!.', 'error');
      return;
    }
    
    //if (this.doituongSelect.Ten == null || this.doituongSelect.Ten == "") {
    //  swal('Lỗi!', 'Vui lòng nhập tên tham số!.', 'error');
    //  return;
    //}

    console.log(this.doituongSelect);

    this.repo.postRequest("api/tuvankhoahoc/addorupdate", this.doituongSelect)
      .subscribe(response => {
        console.log(response);
        if (response != null) {
          this.doituongSelect.Id = response;
          this.save.emit(this.doituongSelect);
        }
        else
          swal('Cảnh báo!', response, 'warning');

      });
  }


}

